import styled from 'styled-components'

export const RadioButtonLabel = styled.label<{
  weight: string
  size: string
  disabled: boolean
}>`
  font-weight: ${({ weight }) => weight};
  display: block;
  position: relative;
  padding-left: ${({ size }) => size === '14px' ? '25px': '48px'}; 
  cursor: pointer;
  font-size: ${({ size }) => size};
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: pre-line;

  :hover input ~ span::after {
    background-color: ${({ theme, disabled }) =>
    disabled ? theme.colors.backgroundGrayDark : theme.colors.primary};
  }

  input:checked ~ span:after {
    display: none;
  }

  input:checked ~ span {
    background-color: ${({ theme, disabled }) =>
    disabled ? theme.colors.backgroundGrayDark : theme.colors.primary};
  }

  span::after {
    content: '';
    position: absolute;
  }
`

export const RadioButtonInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`

export const RadioButtonMark = styled.span<{
  size: string
  disabled: boolean
}>`
  position: absolute;
  top: ${({ size }) => size === '14px' ? '1px': '40%'};
  left: 4px;
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.colors.backgroundGrayDark : theme.colors.primary};
  border: 1px solid
    ${({ theme, disabled }) =>
    disabled ? theme.colors.backgroundGrayDark : theme.colors.primary};

  ::after {
    top: 3px;
    left: 3px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${({ theme, disabled }) =>
    disabled ? theme.colors.backgroundGrayDark : theme.colors.white};
  }
`
